import { Modal as ModalMui } from '@mui/base/Modal';
import cx from 'classnames';
import { forwardRef, ReactNode } from 'react';

import styles from './styles.scss';

interface ModalProps {
  isClose: boolean;
  setIsClose: (isClose: boolean) => void;
  children: ReactNode;
}

export const Modal = ({ isClose, setIsClose, children }: ModalProps) => {
  return (
    <ModalMui
      open={!isClose}
      onClose={() => setIsClose(true)}
      slots={{ backdrop: Backdrop }}
      className={styles.baseModal}
    >
      <div className={styles.modalContent}>{children}</div>
    </ModalMui>
  );
};

interface BackdropProps {
  open?: boolean;
  className: string;
}

const Backdrop = forwardRef<HTMLDivElement, BackdropProps>((props, ref) => {
  const { open, className, ...other } = props;

  return (
    <div
      className={cx(styles.backdrop, className, { 'base-Backdrop-open': open })}
      ref={ref}
      {...other}
    />
  );
});
